// จัดกลุ่มบรรทัดในรายงานภาษีขายตามประเภทภาษี
//
// ที่จับคือ `SLTS.ATT.TypeCode` (คีย์ย่อ `TC`) ของแต่ละรายการสินค้า ซึ่งเป็นค่าเดียวกับ
// <ram:TypeCode> ใน XML ที่ยื่นกรมสรรพากร ตามรหัส UN/EDIFACT 5153:
//   VAT + อัตรา 700 (เก็บเป็นจำนวนเต็มคูณ 100) = VAT 7%
//   VAT + อัตรา 0                              = VAT 0% (อัตราศูนย์)
//   FRE                                        = ยกเว้นภาษี ไม่มีอัตราติดมาด้วย
//
// ตัวเซ็นเอกสารแยก FRE ออกจาก VAT อยู่แล้ว (etax-signer/src/modules/xmler.js) แต่ขา
// นำเข้าของระบบนี้ยัง hardcode เป็น 'VAT' ทุกเส้นทาง (apiDocsSet, expressLibrary,
// store/modules/doc.js) เอกสารที่มีอยู่จึงยังไม่มีใบไหนเป็น FRE — กลุ่มนี้จะว่าง
// จนกว่าขานำเข้าจะเขียนค่ามาให้

import { isExemptDoc } from "@/libs/vatSplit"

export const VAT_7 = "vat7"
export const VAT_0 = "vat0"
export const VAT_FRE = "fre"
export const VAT_TYPES = [VAT_7, VAT_0, VAT_FRE]

export const VAT_TYPE_OPTIONS = [
  { text: "VAT 7%", value: VAT_7 },
  { text: "VAT 0%", value: VAT_0 },
  { text: "ยกเว้นภาษี (FRE)", value: VAT_FRE },
]

export const VAT_TYPE_LABELS = {
  [VAT_7]: "ยอดขาย 7%",
  // ป้ายเดิมของรายงาน ไม่เปลี่ยน เพราะเอกสารที่มีอยู่ทั้งหมดลงอยู่บรรทัดนี้
  [VAT_0]: "ยอดขายได้รับการยกเว้นภาษี",
  [VAT_FRE]: "ยอดขายยกเว้นภาษี (FRE)",
}

// part คือส่วนหนึ่งของเอกสารที่ getVatSplit แบ่งไว้ หรือทั้งใบเมื่อแบ่งไม่ได้
export function rowVatCategory(doc, part) {
  if (!part) {
    return VAT_0
  }
  // ส่วนที่ getVatSplit บอกประเภทมาแล้ว ไม่ต้องเดาต่อ
  if (part.category) {
    return part.category
  }
  // ส่วนที่ถูกทำเครื่องหมายว่าเป็นฝั่งอัตราศูนย์ไว้ แต่ไม่ได้บอกประเภทมาด้วย
  if (part.isVatZeroRow) {
    return VAT_0
  }
  // ทั้งใบเป็นกลุ่มเดียว — ยกเว้นภาษีทั้งใบมาก่อน เพราะใบแบบนี้ไม่มีอัตราให้ดู
  if (isExemptDoc(doc)) {
    return VAT_FRE
  }
  const raw = part.raw || {}
  // มีภาษีติดมาด้วย = เป็นยอดที่คิด VAT แน่นอน
  if (Number(raw.tax)) {
    return VAT_7
  }
  // เอกสารอัตราเดียวที่ภาษีเป็นศูนย์ ให้ดูอัตราที่หัวเอกสาร
  const headerRate = Number(doc && doc["SCTT.AHTS.ATT.CalculatedRate"]) || 0
  return headerRate > 0 ? VAT_7 : VAT_0
}

export default rowVatCategory
